import { useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MotoIcon } from "./MotoIcon";
import { PitStopChat } from "./PitStopChat";

export function PitStopButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isWheeling, setIsWheeling] = useState(false);

  const handleClick = useCallback(() => {
    if (!isOpen) {
      setIsWheeling(true);
      setTimeout(() => {
        setIsWheeling(false);
        setIsOpen(true);
      }, 500);
    } else {
      setIsOpen(false);
    }
  }, [isOpen]);

  return (
    <>
      {/* Inline Moto Button for header */}
      <motion.button
        onClick={handleClick}
        className="relative p-1 rounded-full bg-card/80 border border-primary/30 shadow-sm hover:shadow-neon transition-shadow"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        title="Pit-Stop AI"
      >
        <MotoIcon isWheeling={isWheeling} size="xs" />
        
        {/* Subtle pulse ring - active indicator */}
        <AnimatePresence>
          {!isOpen && (
            <motion.div
              className="absolute inset-0 rounded-full border border-primary/50"
              initial={{ scale: 1, opacity: 0.4 }}
              animate={{ scale: 1.5, opacity: 0 }}
              transition={{ duration: 2, repeat: Infinity }}
            />
          )}
        </AnimatePresence>
      </motion.button>

      {/* Chat Panel */}
      <PitStopChat isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
